import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextInput from '@narvar/nth-text-input';
import { receiveAttestationValue } from '../../actions/returnSubmission';

const Container = styled.div`
  max-width: 520px;
  margin: 0 auto;
`;

const Description = styled.div`
  margin-bottom: 1rem;
  text-align: center;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
  label {
    pointer-events: none;
  }
`;

const mapStateToProps = ({
  returnsSettings: { returns: { attestation: { requiredFields } = {} } = {} } = {},
  language,
  returnSubmission: { attestation } = {},
}) => ({
  requiredFields,
  data: attestation,
  language,
});

const Attestation = ({ dispatch, requiredFields, data, language }) => {
  if (!requiredFields) return null;

  return (
    <Container>
      {language['returns.step_3.attestation.description'] && (
        <Description>{language['returns.step_3.attestation.description']}</Description>
      )}
      <InputContainer>
        {requiredFields.map((field) => (
          <TextInput
            className="fs-exclude"
            defaultValue={data[field]}
            value={data[field]}
            label={language[`returns.step_3.attestation.field.${field}`]}
            onChange={({ target: { value = '' } } = {}) => {
              dispatch(receiveAttestationValue({ field, value }));
            }}
          />
        ))}
      </InputContainer>
    </Container>
  );
};

Attestation.defaultProps = {
  requiredFields: undefined,
  data: {},
};

Attestation.propTypes = {
  dispatch: PropTypes.func.isRequired,
  requiredFields: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.object,
  language: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(Attestation);
